/* Aromahain — scroll reveal + AJAX add-to-cart (progressive enhancement, no deps). */
(function () {
  /* ---------- Reveal on scroll ---------- */
  var html = document.documentElement;
  if ('IntersectionObserver' in window && document.visibilityState !== 'hidden') {
    html.classList.add('ah-js');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -6% 0px', threshold: 0.05 });
    /* revamp 2026: comparsa sobria delle sezioni home sotto la piega (mai hero/primo schermo) */
    document.querySelectorAll('.ahs-s .ahs-hd, .ahs-s .ahs-pg, .ahs-s .ahs-fc, .ahs-s .ahs-chips, .ahs-ed, .ahs-wg, .ahs-end .ahs-w, .ah-ritual__head, .ah-ritual__grid').forEach(function (el) {
      if (el.getBoundingClientRect().top > innerHeight) el.setAttribute('data-ah-reveal', '');
    });
    var scan = function () {
      document.querySelectorAll('[data-ah-reveal]:not(.is-in)').forEach(function (el) { io.observe(el); });
    };
    scan();
    document.addEventListener('shopify:section:load', scan);
    setTimeout(function () {
      document.querySelectorAll('[data-ah-reveal]:not(.is-in)').forEach(function (el) {
        if (el.getBoundingClientRect().top < innerHeight * 1.2) el.classList.add('is-in');
      });
    }, 2500);
    document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'visible') scan(); });
  }

  /* ---------- AJAX add-to-cart for .ah-add-form (falls back to normal POST if fetch fails) ---------- */
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  function toast(msg, href, label) {
    var t = document.getElementById('ah-toast');
    if (!t) {
      t = document.createElement('div'); t.id = 'ah-toast'; t.setAttribute('role', 'status');
      t.style.cssText = 'position:fixed;left:50%;bottom:24px;transform:translateX(-50%);z-index:9999;background:#2F3B36;color:#F4F1EA;padding:14px 20px;border-radius:999px;font:500 14px/1.3 Inter,system-ui,sans-serif;box-shadow:0 10px 30px rgba(0,0,0,.18);display:flex;gap:14px;align-items:center;max-width:92vw';
      document.body.appendChild(t);
    }
    t.innerHTML = '<span>' + msg + '</span>' + (href ? '<a href="' + href + '" style="color:#F4F1EA;text-decoration:underline;text-underline-offset:3px;white-space:nowrap">' + (label || 'Warenkorb ansehen') + ' &rarr;</a>' : '');
    t.style.opacity = '1';
    clearTimeout(t._h); t._h = setTimeout(function () { t.style.opacity = '0'; }, 4500);
  }
  function bumpCartCount(count) {
    document.querySelectorAll('.cart-bubble__text-count').forEach(function (el) { el.textContent = count; el.classList.remove('hidden'); });
    document.querySelectorAll('.cart-bubble').forEach(function (el) { el.classList.remove('visually-hidden'); });
    document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { source: 'aromahain', itemCount: count } }));
  }
  document.addEventListener('click', function (ev) {
    var btn = ev.target.closest && ev.target.closest('.ah-add-set');
    if (!btn || !window.fetch) return;
    var ids = (btn.getAttribute('data-ids') || '').split(',').filter(Boolean);
    if (!ids.length) return;
    var original = btn.textContent; btn.disabled = true;
    fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: ids.map(function (id) { return { id: Number(id), quantity: 1 }; }) }) })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return fetch(root + 'cart.js', { headers: { 'Accept': 'application/json' } }); })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        bumpCartCount(cart.item_count);
        btn.textContent = btn.getAttribute('data-done') || '\u2713 Set im Warenkorb'; btn.disabled = false;
        setTimeout(function () { btn.textContent = original; }, 3000);
        var tpl = btn.getAttribute('data-toast');
        toast(tpl ? tpl.replace('[count]', cart.item_count) : 'Set hinzugef\u00fcgt \u00b7 ' + cart.item_count + ' Artikel im Warenkorb', root + 'cart', btn.getAttribute('data-cart-label'));
      })
      .catch(function () { btn.disabled = false; window.location.href = root + 'cart/' + ids.map(function (id) { return id + ':1'; }).join(','); });
  });
  /* L'aggiunta al carrello delle card custom e' gestita da assets/ah-cart.js (modulo, eventi Horizon). */
})();

/* 26/09 sera: finché il banner cookie è visibile, la barra "In den Warenkorb" fissa della scheda prodotto sale sopra il banner */
(function () {
  function set() {
    var b = document.getElementById('shopify-pc__banner');
    var h = b && b.offsetParent !== null ? Math.round(b.getBoundingClientRect().height) : 0;
    document.documentElement.style.setProperty('--ah-pc-h', h + 'px');
  }
  try { new MutationObserver(set).observe(document.body, { childList: true }); } catch (e) {}
  document.addEventListener('visitorConsentCollected', function () { setTimeout(set, 60); });
  document.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('#shopify-pc__banner')) setTimeout(set, 300); }, true);
  addEventListener('resize', set, { passive: true });
  setTimeout(set, 800); setTimeout(set, 2500);
})();

/* 27/09: SOLO con consenso marketing, il clic dell'annuncio (gclid/gbraid/wbraid) e le UTM vengono salvati
   negli attributi del carrello: ogni ordine porta il suo clic, anche se il tag nel browser viene bloccato.
   Serve per il controllo in Shopify e per l'import delle conversioni in Google Ads. Senza consenso non salva nulla. */
(function () {
  var KEYS = ['gclid', 'gbraid', 'wbraid', 'utm_source', 'utm_medium', 'utm_campaign'];
  function run() {
    try {
      var cp = window.Shopify && Shopify.customerPrivacy;
      if (!cp || !cp.marketingAllowed || !cp.marketingAllowed()) return;
      var q = new URLSearchParams(location.search), st = {}, changed = false;
      try { st = JSON.parse(localStorage.getItem('ah_click') || '{}'); } catch (e) {}
      KEYS.forEach(function (k) { var v = q.get(k); if (v && st[k] !== v) { st[k] = String(v).slice(0, 200); changed = true; } });
      if (!st.gclid) { var m = document.cookie.match(/_gcl_aw=GCL\.\d+\.([^;]+)/); if (m) { st.gclid = m[1]; changed = true; } }
      if (changed) { st.ts = new Date().toISOString(); localStorage.setItem('ah_click', JSON.stringify(st)); }
      if (!st.gclid && !st.gbraid && !st.wbraid && !st.utm_source) return;
      var sig = JSON.stringify(st);
      if (sessionStorage.getItem('ah_click_sent') === sig) return;
      var attrs = {};
      KEYS.forEach(function (k) { if (st[k]) attrs['_' + k] = st[k]; });
      if (st.ts) attrs['_click_ts'] = st.ts;
      var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      fetch(root + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: attrs }) })
        .then(function (r) { if (r.ok) sessionStorage.setItem('ah_click_sent', sig); });
    } catch (e) {}
  }
  window.ahClickAttr = run;
  document.addEventListener('visitorConsentCollected', function () { setTimeout(run, 300); });
  if (window.Shopify && Shopify.loadFeatures) {
    Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (e) { if (!e) run(); });
  } else { setTimeout(run, 1500); }
})();
